// extracted by mini-css-extract-plugin
export var quantityInput = "_pk-0";